import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { passwordEditAPI } from 'api/password'

type StateValue = {
  formValues?: {
    password: string
    currentPassword: string
  }
}

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const stateValue = React.useMemo(() => (location.state ?? {}) as StateValue, [location])
  const { formValues } = stateValue
  const newPassword = formValues?.password
  const currentPassword = formValues?.currentPassword
  const email = localStorage.getItem('email')

  const handleConfirm = async () => {
    if (!newPassword || !currentPassword || !email) {
      alert('パスワード変更に失敗しました。再度、ログインしてください。')
      return navigate('/login')
    }

    await passwordEditAPI({ newPassword, currentPassword, email }, (result) => {
      if (!result) {
        alert('パスワード変更に失敗しました。パスワードをご確認の上、再度お試しください。')
        return navigate('/passwordEdit')
      }
      return navigate('/myPage')
    })
  }

  return (
    <>
      <Header title="パスワード変更確認" />
      <main>
        <section className="mx-4 my-5">
          <p>変更したパスワードはご自身で管理をお願いいたします。 上記をご確認の上、以下の「変更する」ボタンを押してください。</p>
          <div className="mt-5">
            <Button variant="primary" className="w-100 py-4" onClick={handleConfirm}>
              変更する
            </Button>
          </div>
          <div className="m-4 text-center">
            <a href="/myPage">キャンセル</a>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
